/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum QueryValues {
    TestLogin = 'TestLogin',
}
